import { getSupabaseAnonKey, getSupabaseClient, getSupabaseUrl } from '@/api/supabaseClient';

export async function notifyAdminsAboutIntake({ type, recordId }) {
  const normalizedType = String(type || '').trim();
  const normalizedRecordId = String(recordId || '').trim();
  if (!normalizedType || !normalizedRecordId) return { success: false, skipped: true };

  const supabase = getSupabaseClient();
  const { data: sessionData } = await supabase.auth.getSession().catch(() => ({ data: null }));
  const accessToken = sessionData?.session?.access_token || getSupabaseAnonKey();

  const response = await fetch(`${getSupabaseUrl()}/functions/v1/notify-admin-intake`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      apikey: getSupabaseAnonKey(),
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      type: normalizedType,
      record_id: normalizedRecordId,
    }),
  });

  const data = await response.json().catch(() => null);
  if (!response.ok || data?.success === false) {
    throw new Error(data?.error || `notify-admin-intake failed: HTTP ${response.status}`);
  }

  return data;
}
